((Recommendations) => {
  'use strict';

  const MAX_PRODUCTS = 2;
  const selectors = {
    recommendations: '[data-recommendations]',
    insertion: '[data-recommendations-items-insertion]',
    product: '[data-recommendations-product]',
    productImage: '[data-product-image]',
    optionSwatch: '[data-swatch]',
    moreSwatches: '[data-more-swatches]',
    swatchContainer: '[data-swatch-container]'
  };

  const chooseProducts = (items, hideTag) => {
    const products = [];

    if (items.products && items.products.length > 0) {
      for (let i = 0; i < items.products.length; i++) {
        if (products.length >= MAX_PRODUCTS) break;
        if (!items.products[i].available) continue;
        if (items.products[i].tags.indexOf(hideTag) >= 0) continue;

        products.push(items.products[i]);
      }
    }

    return products;
  };

  const insertElements = (insertion, elements) => {
    elements.forEach((element) => {
      insertion.appendChild(element);
    });
  }

  const setupSlider = (element) => {
    $(element).slick({
      arrows: false,
      dots: true
    });
  };

  const setupSwatches = (rec) => {
    const appendVariantToLink = (url, variantId) => {
      if(url.includes('?variant=')) {
        url = url.substring(0, url.indexOf('?variant=')); // strip param
      }
      return `${url}?variant=${variantId}`;
    }

    // set up swatches to set image and link on change
    const swatches = rec.querySelectorAll(selectors.optionSwatch);
    swatches.forEach(swatch => {
      swatch.addEventListener('click', (event) => {
        const current = event.target;
        const imageSource = current.getAttribute('data-image-src');
        const variantId = current.getAttribute('data-color-variant');
        const currentTile = current.closest(selectors.product);
        const productImage = currentTile.querySelector(selectors.productImage);
        const productUrl = currentTile.querySelector('a').getAttribute('href');
        const anchors = currentTile.querySelectorAll('a[href]');

        // remove swatch active class
        const localSwatches = currentTile.querySelectorAll('.swatch');
        localSwatches.forEach(localSwatch => localSwatch.classList.remove('active'));
        // set active swatch
        current.closest('.swatch').classList.add('active');
        // set active image
        productImage.setAttribute('src', imageSource);
        // set anchors
        anchors.forEach(a => a.setAttribute('href', appendVariantToLink(productUrl, variantId)))
      })
    });
  }

  const setupMoreSwatchListeners = (rec) => {
    // set up any scroll buttons for more swatches
    const moreSwatchesBtn = rec.querySelector(selectors.moreSwatches);

    if(!moreSwatchesBtn) return;

    moreSwatchesBtn.addEventListener('click', (event) => {
      const wrapper = event.currentTarget.parentElement;
      const container = wrapper.querySelector(selectors.swatchContainer);
      const scrollPosLeft = container.scrollLeft;
      container.scrollLeft += 25;
      if((container.scrollLeft - scrollPosLeft) === 0) {
        container.scrollLeft = 0;
      } else if ((container.scrollLeft - scrollPosLeft) <= 24) {
        container.scrollLeft += 25;
      }
    });
  }

  const setup = async (rec) => {
    const id = rec.getAttribute('data-recommendations-id');
    const hideTag = rec.getAttribute('data-recommendations-hide-tag');
    const items = await fetch(`/recommendations/products.json?product_id=${id}&limit=10`)
      .then(data => data.json());
    const products = chooseProducts(items, hideTag);
    const elements = [];

    for (let i = 0; i < products.length; i++) {
      const productElement = await fetch(`/products/${products[i].handle}?view=recommendation`)
        .then(response => response.text())
        .then((html) => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          return doc.querySelector('[data-recommendations-product]')
        })
      elements.push(productElement);
    }

    const insertion = rec.querySelector(selectors.insertion);
    insertElements(insertion, elements);
    if(window.innerWidth < 801) setupSlider(insertion);
    setupSwatches(rec);
    setupMoreSwatchListeners(rec);

    rec.style.display = 'block';
    rec.style.opacity = 1;
  };

  const init = () => {
    const recommendations = window.Helpers.toArray(
      document.querySelectorAll(selectors.recommendations)
    );

    if (!recommendations.length) return;

    recommendations.forEach((rec) => {
      setup(rec);
    });
  };

  Recommendations.init = init;
})(window.Recommendations = window.Recommendations || {})